export enum StorageNamesEnum {
  KNM_LIST_TABLE_COLUMNS = 'KNM_LIST_TABLE_COLUMNS',
  KNM_LIST_ORDER = 'KNM_LIST_ORDER',
  KNM_FILTER = 'KNM_FILTER',
  KNM_FILTER_ON = 'KNM_FILTER_ON',
  PM_FILTER = 'PM_FILTER',
  PM_FILTER_ON = 'PM_FILTER_ON',
  DECISION_FILTER = 'DECISION_FILTER',
  DECISION_FILTER_ON = 'DECISION_FILTER_ON',
  PLAN_FILTER = 'PLAN_FILTER',
  PLAN_FILTER_ON = 'PLAN_FILTER_ON',
  SIMILARITIES_LIST_ORDER = 'SIMILARITIES_LIST_ORDER',
  ERKNM_ANALYTICS_COLUMNS = 'ERKNM_ANALYTICS_COLUMNS',
  CERT_SERIAL_NUMBER = 'CERT_SERIAL_NUMBER',
  USER_FIRST_LOGIN = 'USER_FIRST_LOGIN',
  SHOWED_GENERAL_PROSECUTOR_ADDED = 'SHOWED_GENERAL_PROSECUTOR_ADDED',
  AGREEMENT_LIST_TABLE_COLUMNS = 'AGREEMENT_LIST_TABLE_COLUMNS',
  AGREEMENT_LIST_ORDER = 'AGREEMENT_LIST_ORDER',
  AGREEMENT_LIST_FILTER = 'AGREEMENT_LIST_FILTER',
  AGREEMENT_LIST_FILTER_ON = 'AGREEMENT_LIST_FILTER_ON',
}
